export default "__VITE_ASSET__D95vky93__"